import { cn } from '@/lib/utils';

import { Colors, FontSizes } from '@/styles/types';

export type TextProps = {
  children: React.ReactNode;
  as?: 'p' | 'div' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  color?: Colors;
  variant?: FontSizes;
  classNames?: {
    wrapper?: string;
  };
} & React.HTMLAttributes<HTMLSpanElement>;

export function Text({
  as,
  children,
  classNames,
  color = 'gray-950',
  variant = 'body-l',
  ...rest
}: TextProps) {
  const Tag = (as || 'p') as React.ElementType;

  return (
    <Tag
      className={cn(
        `text-${color} text-${variant} break-words font-mono`,
        classNames?.wrapper
      )}
      data-tracker-component='text'
      {...rest}
    >
      {children}
    </Tag>
  );
}
